import CompeteProvider from "./CompeteProvider";
import CompeteContext from "./context";

export default CompeteContext;
export { CompeteProvider };
